import moment from "moment";
import { initialFilters, periods } from "../constants";

export const accountsReceivableColumns = [
  {
    label: "Descrição",
    id: "description",
    style: {
      whiteSpace: "nowrap",
    },
    format: (item) => item ?? "Sem descrição",
  },
  {
    label: "IDCR",
    id: "id",
  },
  {
    label: "Documento",
    id: "document",
  },
  {
    label: "Data Emissão",
    minWidth: 125,
    id: "date",
    format: (item) => moment(item, "YYYY-MM-DD").format("DD/MM/YYYY"),
  },
  {
    label: "Data Vencto",
    minWidth: 125,
    id: "expirationDate",
    format: (item) => moment(item, "YYYY-MM-DD").format("DD/MM/YYYY"),
  },
  {
    label: "Data Recbto",
    minWidth: 125,
    id: "receiptDate",
    format: (item) =>
      !item ? " - " : moment(item, "YYYY-MM-DD").format("DD/MM/YYYY"),
  },
  {
    label: "Valor a Receber (R$)",
    id: "documentAmount",
    align: "right",
    minWidth: 132,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Total Recebido (R$)",
    id: "finishedAmount",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Acréscimos (R$)",
    id: "increase",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Descontos (R$)",
    id: "discount",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Valor Original (R$)",
    id: "originalAmount",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Situação",
    id: "status",
  },
];

export const participantTypes = {
  Todos: "all",
  Fornecedor: "supplier",
  Colaborador: "employee",
  Cliente: "customer",
  Vendedor: "seller",
  "Parceiro Comercial": "businessPartner",
};

export const situations = [
  { desc: "Abertos", id: "open", checked: true },
  { desc: "Vencidos", id: "expired", checked: false },
  { desc: "Recebidos", id: "received", checked: false },
];

export const receiptDates = {
  Emissão: "emission",
  Vencimento: "expiration",
  Recebimento: "receipt",
  Crédito: "credit",
};

export const groupBy = {
  "Sem agrupamento": "no-group",
  Data: "date",
  "Razão Social": "name",
  Situação: "situation",
};

export const sortBy = {
  Data: "date",
  "Razão Social": "name",
  "Valor a Receber": "documentAmount",
  "Valor Original": "originalAmount",
};

export const sortDirections = {
  asc: "asc",
  desc: "desc",
};

export const receiptDateInitialFilters = {
  multicompany: initialFilters.multicompany,
  period: periods["Este mês"],
  startDate: initialFilters.startDate,
  endDate: initialFilters.endDate,
  group: groupBy["Sem agrupamento"],
  dateFilter: receiptDates.Emissão,
  sort: sortBy.Data,
  sortDirection: sortDirections.asc,
  quickStatus: situations[0].id,
};

export const dateLabels = {
  expiration: `vencidos`,
  emission: "emitidos",
  payment: "pagos",
};

export const emptyDescription = {
  date: "Sem data",
  name: "Sem descrição",
  situation: "Sem situação",
};
